import { useParams } from 'react-router-dom';
import { useState, useContext, useEffect } from 'react';
import { useGet } from '@/query/fetchHooks';
import { TEOLoader } from '@teo/components';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { NavContext } from '@/components/NavContext';
import CorrectionHeader from '@/components/LearningPath/Correction/CorrectionHeader';
import CorrectionContent from '@/components/LearningPath/Correction/CorrectionContent';
import { sortDataLP } from '@/components/LearningPath/util';
import CorrectionEvaluation from './CorrectionEvaluation';
import { newUid } from '@/util';

function ResultPage() {
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user;
  const { setNavDisabled } = useContext(NavContext);
  const { organisationId, lpgroupId, studentId } = useParams();
  const [learningpath, setLearningpath] = useState();
  const [student, setStudent] = useState();
  const [nodeStatuses, setNodeStatuses] = useState(null);
  const [allCategories, setAllCategories] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [refreshSub, setRefreshSub] = useState(newUid(10));

  const [evaluationContent, setEvaluationContent] = useState({
    open: false,
    node: null,
    studentId: null,
    Icon: null,
  });

  useGet(`/memberlpgroupdetail/${organisationId}/${lpgroupId}`, {
    retry: false,
    onSuccess: (res) => {
      setLearningpath(res?.data || undefined);
    },
  });

  const { refetch: refetchResult } = useGet(`/lpnodestatuses`, {
    enabled: !!learningpath,
    lpgroupId: lpgroupId,
    userId: studentId,
    onSuccess: (res) => {
      setRefresh(false);
      const nodedetails = res?.data?.filter(
        (el) =>
          el?.type !== 'root' &&
          el?.learningpathId === learningpath?.learningpathId
      );

      const nodedetailsStatus = nodedetails?.map((el) => {
        if (el?.progress === 1) {
          if (el?.isCorrected === true) {
            if (
              el?.subType === 'milestone' ||
              el?.minScore === 0 ||
              el.score / el.maxScore >= el.minScore ||
              (el?.score === 0 && el.maxScore === 0)
            ) {
              return { ...el, done: true, pass: true, needCheck: false };
            } else {
              return { ...el, done: true, pass: false, needCheck: false };
            }
          } else {
            return { ...el, done: true, pass: false, needCheck: true };
          }
        } else {
          return { ...el, done: false, pass: false, needCheck: false };
        }
      });

      if (nodedetails?.length > 0) {
        const sortData = sortDataLP(nodedetailsStatus);
        setNodeStatuses(sortData);
      }
      setRefresh(false);
      setRefreshSub(newUid(10));
    },
  });

  useGet(`/mylpfollows`, {
    enabled: !!learningpath,
    userId: authUser?.id,
    organisationId: authUser?.activeOrganisationId,
    lpgroupId: learningpath?.id,
    studentId: studentId,
    onSuccess: (result) => {
      setStudent(result?.data[0] || null);
    },
  });
  useGet(`/categories`, {
    sort: 'tag',
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    onSuccess: (result) => {
      setAllCategories(
        result?.data?.map((el) => ({
          id: el.id,
          label: el.tag,
          icon: el.icon,
        })) || []
      );
    },
  });

  useEffect(() => {
    setNavDisabled(true);
    return () => setNavDisabled(false);
  });
  // if (refresh) return null;

  return (
    <>
      {refresh ? (
        <div className="m-auto flex min-h-[calc(100vh_-_150px)] p-10">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[100px]"
            />
          </div>
        </div>
      ) : (
        <>
          <CorrectionHeader
            learningpath={learningpath}
            lpgroupId={lpgroupId}
            student={student}
            authUser={authUser}
            setRefresh={setRefresh}
          />
          <CorrectionContent
            key={refreshSub}
            nodeStatuses={nodeStatuses}
            allCategories={allCategories}
            studentId={studentId}
            organisationId={organisationId}
            lpgroupId={lpgroupId}
            setEvaluationContent={setEvaluationContent}
            student={student}
          />
          {evaluationContent?.open && (
            <CorrectionEvaluation
              node={evaluationContent?.node}
              studentId={evaluationContent?.studentId}
              setEvaluationContent={setEvaluationContent}
              student={student}
              learningpath={learningpath}
              Icon={evaluationContent?.Icon}
              refetchResult={refetchResult}
            />
          )}
        </>
      )}
    </>
  );
}

export default ResultPage;
